module.exports = __webpack_public_path__ + "media/Images/icon-laptop-purple-9309dbd5c29b2905d9116ecf7965b2d4.svg";